var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#286a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4AF2C",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "287b",
    width: 20,
    height: 14,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 1.066H2.095c-.578 0-1.047.478-1.047 1.067v11.733c0 .59.469 1.067 1.047 1.067h17.81c.579 0 1.048-.477 1.048-1.067V2.133c0-.589-.47-1.067-1.048-1.067"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#287b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C60000",
    d: "M19.905 1.066H2.095c-.578 0-1.047.478-1.047 1.067v11.733c0 .59.469 1.067 1.047 1.067h17.81c.579 0 1.048-.477 1.048-1.067V2.133c0-.589-.47-1.067-1.048-1.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5B02B",
    fillRule: "evenodd",
    d: "m11 5.095-1.222-.83-.814.83h.814l-.814.83-1.63-.83v4.15l2.444-.832-.814 1.66h-.815l.815.83.814-.83L11 11.733zm1.223-.83.814.83h-.814l.814.83 1.63-.83v4.15l-2.444-.832.814 1.66h.815l-.815.83-.814-.83L11 11.733V5.094z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185D93",
    fillRule: "evenodd",
    d: "M9.429 6.937c0-.885.697-1.605 1.571-1.605.868 0 1.572.718 1.572 1.605v-.365c0 .885-.533 2.086-1.174 2.668L11 9.6l-.398-.359c-.646-.586-1.173-1.781-1.173-2.668z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C58724",
    fillRule: "evenodd",
    d: "M9.429 6.398h3.143v1.067H9.429z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "286a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagMe = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagMe);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";